import { KeyValuePipe } from '@angular/common';
import { Component, effect, inject, signal, WritableSignal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoSelectFields } from '@demo/data/demo-cipo-fields';
import { CipoSelectComponent } from '@shared/components/fields/cipo-select/cipo-select.component';
import { CipoFieldTypes, CipoListConfig, CipoListControl } from '@shared/components/fields/common';
import { UserStore } from '@signal-store/index';

@Component({
  imports: [CipoSelectComponent, FlexLayoutModule, KeyValuePipe],
  templateUrl: './demo-cipo-select.component.html',
})
export class DemoCipoSelectComponent {
  fb = inject(FormBuilder);
  dialog = inject(MatDialog);
  userStore = inject(UserStore);

  form = new FormGroup({});
  FIELD_TYPES = CipoFieldTypes;
  fieldDataMap: Record<string, WritableSignal<CipoListConfig>> = {};

  constructor() {
    DemoSelectFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoListControl(defaultValue, props);
      this.fieldDataMap[name] = signal(props);
      this.form.addControl(name, control);
    });

    setInterval(() => {
      const options = this.fieldDataMap['multiBigSelect']().options || [];
      const nr = options.length + 1;
      this.fieldDataMap['multiBigSelect'].update(fd => ({
        ...fd,
        options: [...options, { key: `option${nr}`, value: `Option ${nr}`, disabled: nr % 3 === 0 }],
      }));
    }, 1000);

    const multiFieldData = {
      label: 'Multi big select (required)',
      multiple: true,
      required: true,
      type: CipoFieldTypes.Select,
    };
    this.fieldDataMap['multiBigSelect'] = signal(multiFieldData);
    this.form.addControl('multiBigSelect', new FormControl([]));

    effect(() => {
      const contractId = this.userStore.contract().id;
      const id = -1016;
      const fieldData: CipoListConfig = {
        label: 'SOVi select',
        hint: 'List saved in store per contract',
        type: CipoFieldTypes.Select,
        dataSourceInfo: {
          contractId,
          id,
        },
      };

      this.fieldDataMap['bigSelect'] = signal(fieldData);
      this.form.setControl('bigSelect', new FormControl(''));
    });
  }
}
